import React, { Component } from "react";
import BannerTitle from "../layouts/about/banner/BannerTitle";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
import { ContentPartners, RelatePartners, Sidebar } from "../layouts/partners";
// import { firestore } from "../../helpers/Firebase";
import data from "../../data/cities.json";

class PartnerAbout extends Component {
  constructor(props) {
    super(props);
    const { location } = props;

    const params = new URLSearchParams(location.search);

    const ID = params.get("id");

    const partnerData = data.cities.find((x) => x.ID === ID);

    this.state = {
      loading: false,
      partnerData: partnerData,
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "Gradovi",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/partners?type=cities",
          titlelink: "Gradovi",
          border: "|",
          name: partnerData?.partnerName,
          heading: partnerData?.partnerName,
        },
      ],
    };
  }

  // FirebaseRemoved
  // componentDidMount() {
  //   this.loadData();
  // }

  // loadData() {
  //   const { location } = this.props;

  //   const params = new URLSearchParams(location.search);

  //   const ID = params.get("id");

  //   if (ID) {
  //     firestore
  //       .doc(`Web/Corporate/DataBase/Cities/DataBase/${ID}`)
  //       .get()
  //       .then((snapshot) => {
  //         const data = snapshot.data();

  //         this.setState({
  //           partnerData: {
  //             ...data,
  //             ID: snapshot.id,
  //           },
  //           loading: false,
  //         });
  //       });
  //   }
  // }

  render() {
    const { loading, partnerData } = this.state;

    return (
      <div className="header-fixed page no-sidebar header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap">
                <div id="site-content" className="site-content clearfix">
                  <div id="inner-content" className="inner-content-wrap">
                    <div className="page-content">
                      <div className="row-project-detail">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={60}
                                data-mobile={60}
                                data-smobile={60}
                              />
                              <div className="detail-inner-wrap">
                                <>
                                  <Sidebar data={partnerData} />
                                  <ContentPartners data={partnerData} />
                                </>
                              </div>
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={58}
                                data-mobile={60}
                                data-smobile={60}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="themesflat-lines style-1 line-full line-solid clearfix">
                                <span className="line" />
                              </div>
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={46}
                                data-mobile={35}
                                data-smobile={35}
                              />
                              <div className="themesflat-headings style-2 clearfix">
                                <h2 className="heading">GRADOVI</h2>
                                <div className="sep has-width w80 accent-bg margin-top-3 clearfix" />
                              </div>
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={35}
                                data-mobile={35}
                                data-smobile={35}
                              />
                              <RelatePartners currentID={partnerData.ID} />
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={80}
                                data-mobile={60}
                                data-smobile={60}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default PartnerAbout;
